import React from 'react'
import PropTypes from 'prop-types'

function DetailRow ({ label, value }) {
  return (
    <div className='__detail-item'>
      <p className='__detail-item-header font-size-xs m-0'>{label}</p>
      <div className='__detail-item-content'>{value || '\u2014'}</div>
    </div>
  )
}

DetailRow.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.node
}

export default DetailRow
